import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import SendIcon from "@material-ui/icons/Send";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TimerIcon from "@material-ui/icons/Timer";
import ChatIcon from "@material-ui/icons/Chat";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PieChartOutlinedIcon from "@material-ui/icons/PieChartOutlined";

const useStyles = makeStyles((theme) => ({
  metricCard: {
    padding: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[2],
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[6]
    }
  },
  metricContent: {
    flex: 1
  },
  metricLabel: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5)
  },
  metricValue: {
    fontSize: "2rem",
    fontWeight: 700,
    color: theme.palette.text.primary
  },
  metricIcon: {
    fontSize: "3rem",
    opacity: 0.8
  },
  iconSuccess: {
    color: "#4caf50"
  },
  iconError: {
    color: "#f44336"
  },
  iconInfo: {
    color: "#2196f3"
  },
  iconWarning: {
    color: "#ff9800"
  },
  iconPrimary: {
    color: theme.palette.primary.main
  }
}));

const MetricsCards = ({ metrics }) => {
  const classes = useStyles();

  if (!metrics) {
    return null;
  }

  const metricItems = [
    {
      label: "Total Enviados",
      value: metrics.totalSent || 0,
      icon: <SendIcon className={`${classes.metricIcon} ${classes.iconInfo}`} />
    },
    {
      label: "Total Entregados",
      value: metrics.totalDelivered || 0,
      icon: <CheckCircleIcon className={`${classes.metricIcon} ${classes.iconSuccess}`} />
    },
    {
      label: "Total Fallidos",
      value: metrics.totalFailed || 0,
      icon: <CancelIcon className={`${classes.metricIcon} ${classes.iconError}`} />
    },
    {
      label: "Tasa de Éxito",
      value: `${metrics.successRate || 0}%`,
      icon: <TrendingUpIcon className={`${classes.metricIcon} ${classes.iconWarning}`} />
    },
    {
      label: "Tiempo Promedio de Entrega",
      value: `${metrics.avgDeliveryTime || 0} min`,
      icon: <TimerIcon className={`${classes.metricIcon} ${classes.iconPrimary}`} />
    },
    {
      label: "Respondieron contacto",
      value: metrics.totalContactReplied || 0,
      icon: <ChatIcon className={`${classes.metricIcon} ${classes.iconPrimary}`} />
    },
    {
      label: "% respuesta (sobre entregados)",
      value: `${metrics.replyRateOfDeliveredPct ?? 0}%`,
      icon: (
        <PieChartOutlinedIcon
          className={`${classes.metricIcon} ${classes.iconPrimary}`}
        />
      )
    },
    {
      label: "IA contestó tras respuesta",
      value: metrics.totalAiRepliedAfterContact || 0,
      icon: <FlashOnIcon className={`${classes.metricIcon} ${classes.iconWarning}`} />
    },
    {
      label: "% IA / entregados",
      value: `${metrics.aiReplyRateOfDeliveredPct ?? 0}%`,
      icon: <TrendingUpIcon className={`${classes.metricIcon} ${classes.iconInfo}`} />
    }
  ];

  return (
    <Box mb={3}>
      <Typography variant="h6" gutterBottom style={{ fontWeight: 600, marginBottom: 16 }}>
        <span role="img" aria-label="gráfico">📊</span> Métricas Generales
      </Typography>
      <Grid container spacing={3}>
        {metricItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper className={classes.metricCard}>
              <Box className={classes.metricContent}>
                <Typography className={classes.metricLabel}>
                  {item.label}
                </Typography>
                <Typography className={classes.metricValue}>
                  {item.value}
                </Typography>
              </Box>
              <Box>{item.icon}</Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MetricsCards;

